<template>
  <dir v-loading="loading">
    <div class="newtj animation swiper-container-horizontal srcospcur">
      <Swiper :options="swiperOptionNews" ref="mySwiperNews">
        <Swiper-slide v-for="item in list" :key="item.id">
          <div class="con clearfix">
            <div class="bg whbfb"></div>
            <div class="img">
              <router-link
                :to="{name:$route.name,params:{pId:$route.params.pId,cId:$route.params.cId},query:{id:item.id}}"
              >
                <img :src="item.imageUrl" />
              </router-link>
              <span>热门推荐</span>
            </div>
            <div class="txt">
              <span>{{item.addDate.split(" ")[0]}}</span>
              <h3>
                <router-link
                  :to="{name:$route.name,params:{pId:$route.params.pId,cId:$route.params.cId},query:{id:item.id}}"
                >{{item.listTitle}}</router-link>
              </h3>
              <p></p>
              <router-link
                :to="{name:$route.name,params:{pId:$route.params.pId,cId:$route.params.cId},query:{id:item.id}}"
                class="more"
              >了解更多</router-link>
            </div>
            <div class="shu">
              <img src="/static/news/ico1.jpg" />
            </div>
          </div>
        </Swiper-slide>
      </Swiper>

      <div class="qhs">
        <a
          href="javascript:;"
          class="qhs01"
          tabindex="0"
          role="button"
          aria-label="Previous slide"
          aria-disabled="true"
        >&lt;</a>
        <div class="newtion">
          <span
            class="swiper-pagination-bullet swiper-pagination-bullet-active"
            tabindex="0"
            role="button"
            aria-label="Go to slide 1"
          ></span>
          <span
            class="swiper-pagination-bullet"
            tabindex="0"
            role="button"
            aria-label="Go to slide 2"
          ></span>
          <span
            class="swiper-pagination-bullet"
            tabindex="0"
            role="button"
            aria-label="Go to slide 3"
          ></span>
          <span
            class="swiper-pagination-bullet"
            tabindex="0"
            role="button"
            aria-label="Go to slide 4"
          ></span>
          <span
            class="swiper-pagination-bullet"
            tabindex="0"
            role="button"
            aria-label="Go to slide 5"
          ></span>
          <span
            class="swiper-pagination-bullet"
            tabindex="0"
            role="button"
            aria-label="Go to slide 6"
          ></span>
        </div>
        <a
          href="javascript:;"
          class="qhs02"
          tabindex="0"
          role="button"
          aria-label="Next slide"
          aria-disabled="false"
        >&gt;</a>
      </div>
      <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
    </div>

    <div class="newlist">
      <ul class="list" v-if="listtwo.length>0">
        <li class="animation srcospcur" v-for="item in listtwo" :key="item.id">
          <router-link
            :to="{name:$route.name,params:{pId:$route.params.pId,cId:$route.params.cId},query:{id:item.id}}"
            class="clearfix"
          >
            <div class="time">
              <p>{{item.addDate|formatDate}}</p>
              <span>{{item.addDate|formatDate("year")}}</span>
            </div>
            <div class="txt">
              <h3>{{item.listTitle}}</h3>
              <span>{{item.addDate.split(" ")[0]}}</span>
              <p></p>
            </div>
            <span class="more">了解详情</span>
          </router-link>
        </li>
      </ul>
      <div class="admin-page">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>
  </dir>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { getNewsList } from "@/api/index";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    id: [Number, String]
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 5,
      contentData: null,
      totalCount: 0,
      list: [],
      listtwo: [],
      swiperOptionNews: {
        autoplay: 5000,
        loop: false,
        nextButton: ".qhs02",
        prevButton: ".qhs01",
        pagination: ".newtion",
        paginationClickable: true
      }
    };
  },
  created() {
    this.loading = true;
    getNewsList({
      pageNo: 0,
      pageSize: 5,
      condition: {
        nodeId: this.$props.id,
        isRecommend: 1
      }
    }).then(res => {
      this.loading = false;
      if (res.data.code == 1000) {
        this.$set(this.$data, "list", res.data.data.data);
        this.$set(this.$data, "totalCount", res.data.data.totalCount);
      }
    });
    this.getNewsListFun({
      pageNo: this.currentPage,
      pageSize: this.pageSize,
      condition: {
        nodeId: this.$props.id
      }
    });
  },
  methods: {
    // 获取二级列表内容
    getNewsListFun(json) {
      getNewsList(json).then(res => {
        if (res.data.code == 1000) {
          this.$set(this.$data, "listtwo", res.data.data.data);
          this.$set(this.$data, "totalCount", res.data.data.totalCount);
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getNewsListFun({
        pageNo: this.currentPage,
        pageSize: val,
        condition: {
          nodeId: this.$props.id
        }
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getNewsListFun({
        pageNo: val,
        pageSize: this.pageSize,
        condition: {
          nodeId: this.$props.id
        }
      });
    }
  }
};
</script>